import { render, staticRenderFns } from "./CsrProjects.ts.vue?vue&type=template&id=8a4da45a&"
import script from "./CsrProjects.ts.vue?vue&type=script&lang=ts&"
export * from "./CsrProjects.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports